/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash e4e439c5688c34963b5b77d5115c8515 */

import { ConcreteRequest } from "relay-runtime";
export type OnlineCheckoutCheck = "DOCUMENT_UPLOAD_NEEDED" | "INVALID_STATE" | "LINK_UBER_NEEDED" | "LINK_UBER_SKIPPED" | "PAYMENT_NEEDED" | "POLICY_LIVE" | "POLICY_SUMMARY" | "TERMS_OF_BUSINESS_NEEDED" | "VERIFY_EMAIL_NEEDED" | "ZEGO_CHECKS_NEEDED" | "%future added value";
export type OnlineCheckoutStatus = "BOUND" | "CHECKS_COMPLETED" | "PAID_FOR" | "PERSONAL_DETAILS_FILLED" | "QUOTE_REFINED" | "QUOTE_SELECTED" | "STARTED" | "%future added value";
export type checkoutPageQueryVariables = {
    category: string;
};
export type checkoutPageQueryResponse = {
    readonly viewer: {
        readonly currentUser: {
            readonly customerNumber: string;
        } | null;
        readonly onlineCheckoutProgress: {
            readonly categoryCode: string;
            readonly status: OnlineCheckoutStatus;
            readonly currentCheck: OnlineCheckoutCheck | null;
            readonly isStatusCompleted: boolean;
            readonly selectedProduct: {
                readonly code: string;
            } | null;
            readonly onlineCheckoutEnabled: boolean;
        } | null;
    };
};
export type checkoutPageQuery = {
    readonly response: checkoutPageQueryResponse;
    readonly variables: checkoutPageQueryVariables;
};



/*
query checkoutPageQuery(
  $category: String!
) {
  viewer {
    currentUser {
      customerNumber
      id
    }
    onlineCheckoutProgress(category: $category) {
      categoryCode
      status
      currentCheck
      isStatusCompleted(status: QUOTE_REFINED)
      selectedProduct {
        __typename
        code
        id
      }
      onlineCheckoutEnabled
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "category",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "customerNumber",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "category",
    "variableName": "category"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryCode",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currentCheck",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isStatusCompleted",
  "args": [
    {
      "kind": "Literal",
      "name": "status",
      "value": "QUOTE_REFINED"
    }
  ],
  "storageKey": "isStatusCompleted(status:\"QUOTE_REFINED\")"
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "onlineCheckoutEnabled",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "checkoutPageQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "currentUser",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "onlineCheckoutProgress",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": "OnlineCheckoutProgress",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "selectedProduct",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [
                  (v7/*: any*/)
                ]
              },
              (v8/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "checkoutPageQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "currentUser",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v9/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "onlineCheckoutProgress",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": "OnlineCheckoutProgress",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "selectedProduct",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v9/*: any*/)
                ]
              },
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "checkoutPageQuery",
    "id": null,
    "text": "query checkoutPageQuery(\n  $category: String!\n) {\n  viewer {\n    currentUser {\n      customerNumber\n      id\n    }\n    onlineCheckoutProgress(category: $category) {\n      categoryCode\n      status\n      currentCheck\n      isStatusCompleted(status: QUOTE_REFINED)\n      selectedProduct {\n        __typename\n        code\n        id\n      }\n      onlineCheckoutEnabled\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '9872485cd6abe7bbb7fddc6ce1489959';
export default node;
